export default "__VITE_ASSET__DtCwhIK3__"